import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { BulkActionListItem } from "@components/common/faro-table/bulk-dialog/content-list/bulk-action-list-item";
import { useBulkActionCallback } from "@hooks/table/use-bulk-action-callback";
import { Box, Stack } from "@mui-wrapper";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { isBulkActionProcessingSelector, updatingItemsSelector } from "@store/table/table-selector";
import { setBulkActionName } from "@store/table/table-slice";
import { getSvgColoredIconCss } from "@styles/common-styles";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { useMemo } from "react";
import { Dialog, Divider, List, Text, XMarkCircleFillIcon } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Dialog for showing bulk action confirmation and report */
export function FaroBulkDialog(t0) {
  const $ = _c(47);
  const {
    dialogContent,
    onClose,
    bulkActionCallback,
    onSuccessfulComplete,
    trackingEvent,
    children,
    shouldDisableConfirmButton: t1,
    selectedEntities,
    uniqueIdKey,
    tableDataType,
    dialogVariant: t2
  } = t0;
  const shouldDisableConfirmButton = t1 === undefined ? false : t1;
  const dialogVariant = t2 === undefined ? "info" : t2;
  const dispatch = useAppDispatch();
  const updatingItems = useAppSelector(updatingItemsSelector);
  const isBulkActionProcessing = useAppSelector(isBulkActionProcessingSelector);
  let t3;
  if ($[0] !== bulkActionCallback || $[1] !== onSuccessfulComplete || $[2] !== selectedEntities || $[3] !== trackingEvent || $[4] !== uniqueIdKey) {
    t3 = {
      selectedEntities,
      uniqueIdKey,
      bulkActionCallback,
      onSuccessfulComplete,
      trackingEvent
    };
    $[0] = bulkActionCallback;
    $[1] = onSuccessfulComplete;
    $[2] = selectedEntities;
    $[3] = trackingEvent;
    $[4] = uniqueIdKey;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    onBulkActionConfirmed
  } = useBulkActionCallback(t3);
  let t4;
  if ($[6] !== updatingItems) {
    t4 = updatingItems.every(_temp);
    $[6] = updatingItems;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const isAllItemsNotAllowed = t4;
  const isConfirmButtonDisabled = shouldDisableConfirmButton || isAllItemsNotAllowed;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      alignItems: "center"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== dialogContent.shouldShowFailedIcon) {
    t6 = dialogContent.shouldShowFailedIcon ? <XMarkCircleFillIcon sx={{
      ...getSvgColoredIconCss(PALETTE_VARS.error.main),
      height: "28px",
      width: "28px",
      mr: "12px"
    }} /> : null;
    $[9] = dialogContent.shouldShowFailedIcon;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== dialogContent.title || $[12] !== t6) {
    t7 = <Stack direction="row" sx={t5}>{t6}{dialogContent.title}</Stack>;
    $[11] = dialogContent.title;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== dialogContent.confirmButtonText) {
    t8 = capitalizeFirstLetter(dialogContent.confirmButtonText);
    $[14] = dialogContent.confirmButtonText;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== dispatch || $[17] !== onClose) {
    t9 = () => {
      dispatch(setBulkActionName(null));
      onClose();
    };
    $[16] = dispatch;
    $[17] = onClose;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      fontSize: "14px",
      mb: SPACE_ELEMENTS_OF_MODAL
    };
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== dialogContent.description) {
    t11 = <Box component="div" sx={t10}>{dialogContent.description}</Box>;
    $[20] = dialogContent.description;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Divider sx={{
      mb: SPACE_ELEMENTS_OF_MODAL
    }} />;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      mb: SPACE_ELEMENTS_OF_MODAL
    };
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== dialogContent.selectedEntitiesReport) {
    t14 = <Text variant="bodyM" component="div" sx={t13}>{dialogContent.selectedEntitiesReport}</Text>;
    $[24] = dialogContent.selectedEntitiesReport;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      maxHeight: "200px",
      overflow: "auto"
    };
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      py: "0px"
    };
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== tableDataType || $[29] !== updatingItems) {
    let t18;
    if ($[31] !== tableDataType) {
      t18 = updatingItem => <BulkActionListItem key={updatingItem.id} item={updatingItem} tableDataType={tableDataType} />;
      $[31] = tableDataType;
      $[32] = t18;
    } else {
      t18 = $[32];
    }
    t17 = updatingItems.map(t18);
    $[28] = tableDataType;
    $[29] = updatingItems;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[33] !== t17) {
    t18 = <Box component="div" sx={t15}><List dense={true} sx={t16}>{t17}</List></Box>;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== children || $[36] !== dialogVariant || $[37] !== isBulkActionProcessing || $[38] !== isConfirmButtonDisabled || $[39] !== onBulkActionConfirmed || $[40] !== t11 || $[41] !== t14 || $[42] !== t18 || $[43] !== t7 || $[44] !== t8 || $[45] !== t9) {
    t19 = <Dialog title={t7} confirmText={t8} open={true} isConfirmDisabled={isConfirmButtonDisabled} onConfirm={onBulkActionConfirmed} onCancel={t9} showSpinner={isBulkActionProcessing} variant={dialogVariant}>{t11}{children}{t12}{t14}{t18}</Dialog>;
    $[35] = children;
    $[36] = dialogVariant;
    $[37] = isBulkActionProcessing;
    $[38] = isConfirmButtonDisabled;
    $[39] = onBulkActionConfirmed;
    $[40] = t11;
    $[41] = t14;
    $[42] = t18;
    $[43] = t7;
    $[44] = t8;
    $[45] = t9;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  return t19;
}
function _temp(item) {
  return item.status === "not-allowed";
}